import {User} from '../lib/user/dto/User';

export class HitFluencerUser extends User {

  constructor() {
    super();
  }

}
